<template>
  <b-card no-body class="h-100">
    <b-card-header class="d-flex justify-content-between align-items-center">
      <h4 class="card-title mb-0">{{ viewMode === 'occupation' ? 'Ocupação dos Recursos' : 'Quantidade de Operações Alocadas' }}</h4>
      <div class="actions d-flex align-items-center">
        <div class="switch-view-icon mr-1 cursor-pointer" @click="toggleView">
          <feather-icon icon="ChevronUpIcon" size="14" style="margin-bottom: -4px;" />
          <feather-icon icon="ChevronDownIcon" size="14" style="margin-top: -4px;" />
        </div>
      </div>
    </b-card-header>
    <b-card-body class="resource-card-body">
      <!-- Occupation View (Progress Bars) -->
      <div v-if="viewMode === 'occupation'">
        <div v-for="(item, index) in data" :key="index" class="resource-item mb-2">
          <div class="d-flex justify-content-between mb-1">
            <span class="text-body">{{ item.name }}</span>
            <div class="d-flex align-items-center">
              <feather-icon :icon="item.trend === 'up' ? 'TrendingUpIcon' : 'TrendingDownIcon'" class="mr-1"
                :class="item.trend === 'up' ? 'text-success' : 'text-danger'" />
              <span class="font-weight-bold">{{ item.value }}%</span>
            </div>
          </div>
          <b-progress height="6px">
            <b-progress-bar :value="item.value" variant="secondary" class="bg-secondary"
              style="opacity: 0.5"></b-progress-bar>
          </b-progress>
        </div>
      </div>

      <!-- Operations Count View (Dotted List) -->
      <div v-else class="operations-list">
        <div v-for="(item, index) in data" :key="index"
          class="operation-item d-flex justify-content-between align-items-end mb-2">
          <span class="text-muted text-truncate" style="max-width: 60%;" :title="item.name">{{ item.name }}</span>
          <div class="dotted-line mx-2"></div>
          <span class="font-weight-bold">{{ item.operationsCount || 0 }}</span>
        </div>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardHeader, BCardBody, BProgress, BProgressBar } from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BProgress,
    BProgressBar
  },
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      viewMode: 'occupation' // 'occupation' or 'count'
    }
  },
  methods: {
    toggleView() {
      this.viewMode = this.viewMode === 'occupation' ? 'count' : 'occupation'
    }
  }
}
</script>

<style scoped>
.resource-item:last-child {
  margin-bottom: 0 !important;
}

.switch-view-icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #6e6b7b;
}

.resource-card-body {
  max-height: 300px;
  overflow-y: auto;
}

/* Custom scrollbar for card body */
.resource-card-body::-webkit-scrollbar {
  width: 6px;
}

.resource-card-body::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.resource-card-body::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 3px;
}

.operations-list {
  padding-right: 5px;
}

.dotted-line {
  flex-grow: 1;
  border-bottom: 1px dashed #babfc7;
  margin-bottom: 5px;
  /* Align with text baseline */
}

.operation-item {
  font-size: 0.95rem;
}
</style>
